import React, { useMemo, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { useSendStepProposal } from "../services";
import { ScreensEnum } from "../../Feedback/Feedback.controller";

import { QuizScreen, QuizScreenProps } from "./Quiz.screen";

interface LocationState {
  quiz: QuestionProps[];
  proposalId: string;
}

interface QuestionProps {
  id: string;
  question?: string;
  type?: string;
  mode?: string;
  options?: { text: string; value: string }[];
}

export interface QuestionStateProps extends QuestionProps {
  valueSelectedQuestion?: string;
}

export interface SelectQuestionProps {
  idQuestion: string;
  valueOption: string;
}

export const QuizController = () => {
  const location = useLocation<LocationState>();
  const quiz = location?.state?.quiz;
  const proposalId = location?.state?.proposalId;
  const [quizState, setQuizState] = useState<QuestionStateProps[]>(quiz || []);

  const history = useHistory();
  const { sendStepProposal } = useSendStepProposal();

  const [loading, setLoading] = useState(false);

  const disabledSubmit = useMemo(() => {
    const selectedQuestions = quizState?.filter(
      (question) => question?.valueSelectedQuestion
    );

    if (selectedQuestions?.length === quizState?.length) {
      return false;
    }

    return true;
  }, [quizState]);

  const onSubmit = useCallback(async () => {
    if (disabledSubmit) {
      return;
    }

    setLoading(true);

    try {
      const answers = quizState?.map((question) => ({
        id: Number(question?.id),
        value: question?.valueSelectedQuestion,
      }));

      const variables = {
        proposal_id: proposalId,
        step: "answer_quiz",
        answer_quiz: answers,
      };

      console.log(variables);

      const response = await sendStepProposal({ variables });

      let type = ScreensEnum.RESGISTRATION_DENIED;

      if (response?.data?.SendProposalStep.status === "approved_topups") {
        type = ScreensEnum.RESGISTRATION_PERFORMED;
      }

      history.replace({
        pathname: "/feedback",
        state: { type, origin: "/signup" },
      });
    } catch (error) {
      console.log({ error });
      setLoading(false);
    }
  }, [disabledSubmit, history, proposalId, quizState, sendStepProposal]);

  const selectQuestion = useCallback(
    (selected: SelectQuestionProps) => (): void => {
      const newQuiz = quizState?.map((question) => {
        if (question.id !== selected.idQuestion) {
          return question;
        }

        return {
          ...question,
          valueSelectedQuestion:
            question?.valueSelectedQuestion === selected?.valueOption
              ? undefined
              : selected?.valueOption,
        };
      });

      setQuizState(newQuiz);
    },
    [quizState]
  );

  const handlers: QuizScreenProps = {
    title: "Validação do cadastro :)",
    subtitle:
      "Esta é a última etapa!\n" +
      "Responda as próximas perguntas, para validarmos a sua identidade e garantirmos " +
      "a segurança do acesso :) ",
    loading,
    disabled: disabledSubmit,
    quiz: quizState,
    selectQuestion,
    onSubmit,
  };

  return <QuizScreen {...handlers} />;
};
